import React from 'react';
import DatePicker from 'react-datepicker';
import ko from 'date-fns/locale/ko'; // 한국어 지역 설정
import { dateFormat } from 'utils/Date.util';

type CommonDatePickerProps = {
    onChange: (value: string) => void;
    selected: Date | null;
    maxDate?: Date | null;
    minDate?: Date | null;
    placeholderText?: string | null;
    id?: string | null;
    mode?: 'daily' | 'monthly'; // 기본 모드 설정
};

function CommonDatePicker(props: CommonDatePickerProps) {
    function handleDateChange(date: Date) {
        if (props.mode === 'monthly') {
            props.onChange(dateFormat(date, 'YYYY-MM'));
        } else {
            props.onChange(dateFormat(date, 'YYYY-MM-DD'));
        }
    }

    function resetDate() {
        props.onChange('');
    }

    return (
        <>
            <div className="input-group-append datepicker-with-btn">
                <DatePicker
                    className="form-control datetimepicker-input"
                    id={props.id}
                    dateFormat={props.mode === 'monthly' ? 'yyyy-MM' : 'yyyy-MM-dd'} // mode에 따라 동적 변경
                    showMonthYearPicker={props.mode === 'monthly'}
                    shouldCloseOnSelect // 날짜를 선택하면 datepicker가 자동으로 닫힘
                    maxDate={props.maxDate} // maxDate 이후 날짜 선택 불가
                    minDate={props.minDate} // minDate 이전 날짜 선택 불가
                    selected={props.selected}
                    onChange={(date) => handleDateChange(date)}
                    placeholderText={props.placeholderText}
                    locale={ko} // 한국어로 지역 설정
                    showMonthDropdown // 월 선택 드롭다운 추가
                    showYearDropdown // 년 선택 드롭다운 추가
                    dropdownMode="select" // 드롭다운 모드를 select로 설정
                    yearDropdownItemNumber={10} // 년도 드롭다운에 표시할 년도 수
                />
            </div>
        </>
    );
}

export default CommonDatePicker;